(() => {
  if (window.cartConsentInitialized) return;
  window.cartConsentInitialized = true;

  const CONSENT_YES = 'yes';
  const CONSENT_NO = 'no';
  const CONSENT_KEY = 'privacy_policy_agreed';
  const CONSENT_AT_KEY = 'privacy_policy_agreed_at';
  const CONSENT_VERSION_KEY = 'privacy_policy_agreed_version';
  const CONSENT_VERSION = '2026-08-14';

  const selectors = {
    root: '[data-cart-consent]',
    checkbox: '[data-cart-consent-checkbox]',
    message: '[data-cart-consent-message]',
    checkout: 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]',
    dynamicCheckout: '.cart__dynamic-checkout-buttons, .additional-checkout-buttons',
  };

  const getConsentRoots = () => Array.from(document.querySelectorAll(selectors.root));

  const setCheckoutBlocked = (blocked) => {
    document.querySelectorAll(selectors.checkout).forEach((button) => {
      const isCartButton = button.closest('[data-cart-consent]') || button.closest('.cart__ctas') || button.id === 'checkout' || button.id === 'CartDrawer-Checkout';
      if (!isCartButton) return;

      button.toggleAttribute('disabled', blocked);
      button.classList.toggle('cart-consent-blocked', blocked);
      button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    });

    document.querySelectorAll(selectors.dynamicCheckout).forEach((container) => {
      container.classList.toggle('cart-consent-blocked', blocked);
      container.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    });
  };

  const setInvalidState = (show) => {
    getConsentRoots().forEach((root) => {
      root.classList.toggle('is-invalid', show);
      const message = root.querySelector(selectors.message);
      if (message) message.hidden = !show;
    });
  };

  const currentChecked = () => getConsentRoots().some((root) => root.querySelector(selectors.checkbox)?.checked);

  const syncCheckboxes = (checked) => {
    getConsentRoots().forEach((root) => {
      const checkbox = root.querySelector(selectors.checkbox);
      if (checkbox) checkbox.checked = checked;
    });
  };

  const isConsentSaved = () => getConsentRoots().some((root) => root.dataset.cartConsentSaved === 'true');

  const markConsentSaved = (saved) => {
    getConsentRoots().forEach((root) => {
      root.dataset.cartConsentSaved = saved ? 'true' : 'false';
    });
  };

  const updateUi = () => {
    const checked = currentChecked();
    syncCheckboxes(checked);
    setCheckoutBlocked(!checked);
    if (checked) setInvalidState(false);
  };

  const updateCartAttributes = async (checked) => {
    getConsentRoots().forEach((root) => root.classList.add('is-saving'));

    const attributes = {
      [CONSENT_KEY]: checked ? CONSENT_YES : CONSENT_NO,
      [CONSENT_AT_KEY]: checked ? new Date().toISOString() : '',
      [CONSENT_VERSION_KEY]: CONSENT_VERSION,
    };

    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes }),
      });

      if (!response.ok) throw new Error('Cart consent update failed');
      markConsentSaved(checked);
    } catch (error) {
      console.error(error);
      syncCheckboxes(false);
      markConsentSaved(false);
      setCheckoutBlocked(true);
      setInvalidState(true);
    } finally {
      getConsentRoots().forEach((root) => root.classList.remove('is-saving'));
    }
  };

  const handleChange = (event) => {
    if (!event.target.matches(selectors.checkbox)) return;

    const checked = event.target.checked;
    syncCheckboxes(checked);
    setCheckoutBlocked(!checked);
    setInvalidState(false);
    updateCartAttributes(checked);
  };

  const handleCheckout = (event) => {
    const target = event.target.closest(selectors.checkout);
    if (!target) return;

    if (currentChecked()) return;

    event.preventDefault();
    event.stopPropagation();
    setCheckoutBlocked(true);
    setInvalidState(true);
    getConsentRoots()[0]?.querySelector(selectors.checkbox)?.focus();
  };

  const init = () => {
    updateUi();
    if (currentChecked() && !isConsentSaved()) {
      updateCartAttributes(true);
    }
  };

  document.addEventListener('change', handleChange);
  document.addEventListener('click', handleCheckout, true);
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('form[action*="/cart"]')) return;
    if (event.submitter?.name !== 'checkout') return;
    if (currentChecked()) return;

    event.preventDefault();
    setCheckoutBlocked(true);
    setInvalidState(true);
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:consent:refresh', init);

  if (document.readyState !== 'loading') init();
})();
